import {ProductExSearchParamType} from "../interface";
import {UseFormRegister, UseFormWatch} from "react-hook-form";

interface PropsType {
    register: UseFormRegister<ProductExSearchParamType>,
    handleSubmit: any,
    watch: UseFormWatch<ProductExSearchParamType>
}

const handleOpenGuide = () => {
        window.open('/product_guide.html', '_blank', 'width=1200,height=800');
};

// 내부수정: 구매 가이드 버튼 위치 변경
export default function Filter({register, handleSubmit, watch}: PropsType) {
    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">제품 검색</h3>
            <div className="filter_toolbar">
                <button className="btn btn-primary w-100px" onClick={handleOpenGuide}>구매 가이드</button>
            </div>
        </div>
        <form className="row" onSubmit={handleSubmit}>
            {/*<div className="col-6">*/}
            {/*    <div className="frm_row search justify-content-start">*/}
            {/*        <label htmlFor="" className="form-label frm_label">카테고리</label>*/}
            {/*        <select className="form-select w-150px">*/}
            {/*            <option>전체</option>*/}
            {/*        </select>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="col-6">*/}
            <div className="frm_row">
                <label htmlFor="" className="form-label frm_label">검색어</label>
                <select className="form-select w-150px" value={watch("keywordType1")} {...register("keywordType1")}>
                    <option value={"1"}>전체</option>
                    <option value={"2"}>벤더</option>
                    <option value={"3"}>카테고리</option>
                    <option value={"4"}>품목</option>
                    <option value={"5"}>규격</option>
                    <option value={"6"}>중분류</option>
                    <option value={"7"}>대분류</option>
                </select>
                <input type="text" className="form-control w-250px ms-5px" {...register("keyword1")}/>
                <button className="btn btn-info btn_search ms-5px">
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                </button>
            </div>
            {/*</div>*/}
        </form>
    </div>
}